import { render, staticRenderFns } from "./filter3500.vue?vue&type=template&id=bd710c46&scoped=true&"
import script from "./filter3500.vue?vue&type=script&lang=js&"
export * from "./filter3500.vue?vue&type=script&lang=js&"
import style0 from "./filter3500.vue?vue&type=style&index=0&id=bd710c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd710c46",
  null
  
)

export default component.exports